import React from 'react'

const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <div className="progress">
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  )
}

export default ProgressBar
